exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".awesome-tick[data-v-06c29f20] {\n  color: #31cc98;\n  font-size: .875rem;\n  display: block;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n.awesome-cross[data-v-06c29f20] {\n  color: #ec6f57;\n  font-size: .875rem;\n  display: block;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n", ""]);

// exports
